import { clone, each, isNil } from 'lodash'

/**
 * Deep search and replaces the given property value "prevVal" with "newVal"
 * @param  {any} prevVal [description]
 * @param  {any} newVal  [description]
 * @param  {object|array} object the original object or array in which the values should be replaced
 * @return {object|array}        the new object or array
 */
export function replacePropertyValue(prevVal:string, newVal:string, object:any): object | Array<any> {
	const newObject = clone(object)

	each(object, (val, key) => {
		/* console.log(`${JSON.stringify(val)}=${typeof (val)}

		`) */
		 if (typeof (val) === 'object') {
			newObject[key] = replacePropertyValue(prevVal, newVal, val)
		} else if (typeof (val) === 'string') {
		 	newObject[key] = val.replace(prevVal, newVal)
		 }
	})

	return newObject
}

export const replaceMenuIds = (id: string | null, object:any) => {
	if (isNil(id)) {
		return object
	}
	return replacePropertyValue('{{ id }}', id, object)
}
